import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../components/Common/ChartsDynamicColor";

const Chart1 = ({ dataColors }) => {
  const apexearningChartColors = getChartColorsArray(dataColors);

  const earningChartData = [31, 40, 36, 51, 49, 72, 69, 72];

  const options = {
    chart: {
      toolbar: "false",
      dropShadow: {
        enabled: !0,
        color: "#000",
        top: 18,
        left: 7,
        blur: 8,
        opacity: 0.2,
      },
    },
    xaxis: {
      categories: [
        "Jan 23",
        "Feb 23",
        "Mar 23",
        "Apr 23",
        "May 23",
        "Jun 23",
        "Jul 23",
        "Aug 23",
      ],
      labels: {
        show: true,
        rotateAlways: false,
        style: {
          fontSize: "10px",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          return val;
        },
      },
    },
    dataLabels: {
      enabled: !1,
    },
    colors: apexearningChartColors,
    stroke: {
      curve: "smooth",
      width: 3,
    },
  };
  const series = [
    {
      name: "Year 2023",
      data: [...earningChartData],
      color: "#34c38f",
    },
  ];

  return (
    <React.Fragment>
      <div>
        <Card>
          <CardBody>
            <div className="clearfix">
              <h4 className="card-title mb-4">Last 6 months Analysis</h4>
            </div>
            <Row>
              <Col lg="8">
                <div style={{ width: "100%" }} id="line-chart" dir="ltr">
                  <ReactApexChart
                    series={series}
                    options={options}
                    type="line"
                    height={320}
                    width={600}
                    className="apex-charts"
                  />
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  );
};

export default Chart1;
